module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ellie-coldiron-c5c1bea788af2401a93d2b877f4079df.jpg";